import React from "react";
import { Box, CardMedia, makeStyles, Typography } from "@material-ui/core";
import photo from "../../../assets/aboutUs/about4.png";

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  container: {
    display: "grid",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "60% 40%",
    overflow: "hidden",
  },
  text: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  paragraph: {
    width: "55%",
    color: "#272727",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "18px",
    textAlign: "end",
    margin: `0 ${spacing(3)}px`,
  },
  year: {
    color: "#272727",
    fontWeight: "bold",
    fontSize: "122px",
    lineHeight: "100%",
    margin: `0 ${spacing(3)}px`,
  },
  img: {
    height: "100%",
  },
}));

const about4 = () => {
  const classes = useStyles();

  return (
    <Box component="div" className={classes.container}>
      <Box component="div" className={classes.text}>
        <Typography className={classes.paragraph} p="true">
          Se mantiene el comercio de veladoras religiosas en varios diseños y
          tamaños. Se empiezan a etiquetar algunas presentaciones con otras
          imágenes representativas de fechas importantes en la cultura religiosa
          guatemalteca. Se incursiona en nuevos equipos y se amplían los canales
          de distribución. Durante este tiempo, muchas de las personas que
          trabajaban para él, fueron capaces de poner sus negocios de
          distribución de velas, gracias a su apoyo e inducción.
        </Typography>
        <Typography className={classes.year} variant="h3">
          1990-2000
        </Typography>
        <Typography className={classes.paragraph} p="true">
          La empresa se vuelve una Sociedad Anónima en la que empiezan a
          involucrarse de manera formal sus hijas, apoyando en las áreas
          logísticas y de desarrollo, brindando a la empresa una visión más
          moderna e innovadora.
        </Typography>
        <Typography className={classes.year} variant="h3">
          2004
        </Typography>
      </Box>
      <Box component="div" className={classes.image}>
        <CardMedia className={classes.img} component="img" image={photo} />
      </Box>
    </Box>
  );
};

export default about4;
